document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMarquee();
  initContadores();
  initGaleria();
  initVariantes();
  initBundle();
  initPasos();
});

function initReveal() {
  var els = document.querySelectorAll('.fb-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('fb-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-fb-delay') || 0;
        setTimeout(function () { entry.target.classList.add('fb-visible'); }, Number(delay));
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('[data-fb-marquee]').forEach(function (wrap) {
    var track = wrap.querySelector('.fb-marquee__track');
    if (!track) return;
    if (track.dataset.fbCloned) return;
    track.innerHTML += track.innerHTML;
    track.dataset.fbCloned = '1';
    var speed = Number(wrap.getAttribute('data-fb-speed') || 40);
    track.style.animationDuration = speed + 's';
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-fb-count]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = Number(el.getAttribute('data-fb-count'));
      var suffix = el.getAttribute('data-fb-suffix') || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-fb-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-fb-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-fb-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('fb-thumb--activo'); });
        thumb.classList.add('fb-thumb--activo');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-fb-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-fb-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = root.querySelectorAll('[data-fb-opcion]');
    var idInput = root.querySelector('[data-fb-variant-id]');
    var precioEl = root.querySelector('[data-fb-precio]');
    var compareEl = root.querySelector('[data-fb-precio-comparado]');
    var ahorroEl = root.querySelector('[data-fb-precio-ahorro]');
    var badgeEl = root.querySelector('[data-fb-badge-descuento]');
    var btn = root.querySelector('[data-fb-add]');
    var estado = root.querySelector('[data-fb-estado]');
    var existenciasEl = root.querySelector('[data-fb-existencias]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN'
      });
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (precioEl) precioEl.textContent = moneda(match.price);
      var conDescuento = match.compare_at_price && match.compare_at_price > match.price;
      if (compareEl) {
        if (conDescuento) {
          compareEl.textContent = moneda(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (ahorroEl) {
        if (conDescuento) {
          ahorroEl.textContent = 'Ahorras ' + moneda(match.compare_at_price - match.price);
          ahorroEl.style.display = '';
        } else {
          ahorroEl.style.display = 'none';
        }
      }
      if (badgeEl) {
        if (conDescuento) {
          var pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
          badgeEl.textContent = '-' + pct + '%';
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
      if (btn) {
        btn.disabled = !match.available;
        var textoBase = btn.getAttribute('data-texto-base') || btn.textContent;
        btn.setAttribute('data-texto-base', textoBase);
        btn.textContent = match.available ? textoBase : (btn.getAttribute('data-texto-agotado') || 'Agotado');
      }
      if (estado) {
        estado.textContent = match.available ? '' : (estado.getAttribute('data-texto-agotado') || 'Agotado temporalmente');
      }
      if (existenciasEl) {
        var rastreado = match.inventory_tracked === 'shopify';
        var cantidad = match.inventory_quantity;
        if (rastreado && cantidad > 0) {
          var plantilla = existenciasEl.getAttribute('data-plantilla') || '¡Solo quedan [cantidad] unidades!';
          existenciasEl.textContent = plantilla.replace('[cantidad]', cantidad);
          existenciasEl.style.display = '';
          var umbral = parseInt(existenciasEl.getAttribute('data-umbral'), 10) || 15;
          existenciasEl.classList.toggle('fb-existencias--baja', cantidad <= umbral);
        } else {
          existenciasEl.style.display = 'none';
        }
      }
      if (match.image) {
        var galeriaPrincipal = document.querySelector('[data-fb-galeria-principal]');
        if (galeriaPrincipal && galeriaPrincipal.src !== match.image) {
          galeriaPrincipal.src = match.image;
          document.querySelectorAll('[data-fb-galeria-thumb]').forEach(function (t) {
            t.classList.toggle('fb-thumb--activo', t.getAttribute('data-full') === match.image);
          });
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function wireCustomPicker(wrapSelector, cardAttr, cardValorAttr, activaClase) {
  document.querySelectorAll(wrapSelector).forEach(function (wrap) {
    var select = wrap.querySelector('select[data-fb-opcion]');
    var cards = wrap.querySelectorAll('[' + cardValorAttr + ']');
    if (!select || !cards.length) return;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var valor = card.getAttribute(cardValorAttr);
        select.value = valor;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        cards.forEach(function (c) { c.classList.remove(activaClase); });
        card.classList.add(activaClase);
      });
    });
  });
}

function initBundle() {
  wireCustomPicker('[data-fb-bundle]', null, 'data-fb-bundle-valor', 'fb-bundle-card--activa');
  wireCustomPicker('[data-fb-swatch]', null, 'data-fb-swatch-valor', 'fb-color-swatch--activo');
}

function initPasos() {
  document.querySelectorAll('[data-fb-pasos]').forEach(function (wrap) {
    var linea = wrap.querySelector('[data-fb-pasos-linea]');
    if (!linea) return;
    if (!('IntersectionObserver' in window)) { linea.style.transform = 'scaleX(1)'; return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          linea.style.transform = 'scaleX(1)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    io.observe(wrap);
  });
}
